import { render, staticRenderFns } from "./OportunityDescription.vue?vue&type=template&id=51d3a897"
import script from "./OportunityDescription.vue?vue&type=script&lang=js"
export * from "./OportunityDescription.vue?vue&type=script&lang=js"
import style0 from "./OportunityDescription.vue?vue&type=style&index=0&id=51d3a897&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports